import { z } from 'zod';
import { ProjectNumberSchema } from './shared';
import { CustomerInfoSchema } from './customer-info.ts';

export const PostPositionRequestSchema = z.object({
    projectNumber: ProjectNumberSchema,
    marketCode: z.string(),
    customerInfo: CustomerInfoSchema,
    salesforceOpportunityId: z.string().optional(),
});
